var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrigamiCrane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.817,
    height: 126.27,
    viewBox: "0 0 126.817 126.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cane_UP",
    "data-name": "Cane UP",
    transform: "translate(0.5 0.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_up",
    "data-name": "arrow up",
    transform: "translate(43.282 76.379)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M1,29.285H-1V0H1Z",
    transform: "translate(30 20)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3-2",
    "data-name": "Line 3",
    d: "M1,17.079H-1V0H1Z",
    transform: "translate(30 14.921)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3-3",
    "data-name": "Line 3",
    d: "M1,17.079H-1V0H1Z",
    transform: "translate(30 14.921)",
    fill: "#dfd9dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3-4",
    "data-name": "Line 3",
    d: "M2,2H0V0H2Z",
    transform: "translate(29 9.207) rotate(-90)",
    fill: "#dfd9dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_x0020_1",
    transform: "translate(-4.2 -4.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3337",
    d: "M2103.808,69.458l20.53,11.71m13.887-21.185L2133.39,4.21l-38.741,55.8,1.024,16.853",
    transform: "translate(-2031.553)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "path3350",
    y1: 71.973,
    x2: 17.792,
    transform: "translate(84.045 4.21)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer18",
    transform: "translate(64.12 69.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3385",
    d: "M2130.98,2191.144l.656,1.526,7.5-8.889Z",
    transform: "translate(-2130.98 -2183.78)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path3292",
    d: "M3392.37,2075.745l1.737.52,7.731-39.365",
    transform: "translate(-3292.711 -1971.801)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3316",
    d: "M3519.343,1820.012l24.364,5.066-19.35-10.988-7.376,2.985",
    transform: "translate(-3413.81 -1755.665)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "path3303",
    x2: 23.879,
    y2: 7.762,
    transform: "translate(106.008 61.678)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2429",
    d: "M59.386,1598.625,4.2,1564.88l45.163,37.145",
    transform: "translate(0 -1513.92)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2460",
    d: "M3027.407,1960.529l7.041-46.842-2.865-.277-13.963,26.854",
    transform: "translate(-2928.519 -1852.01)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3262",
    d: "M2943.888,3068.446l-12.209-6.041,3.424-1.087,5.57-5.779Z",
    transform: "translate(-2845 -2959.928)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2440",
    d: "M1924.6,2200.251l13.969-16.471,23.4,26.114",
    transform: "translate(-1866.294 -2114.281)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "path2455",
    x1: 6.087,
    y1: 23.038,
    transform: "translate(72.274 69.499)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(23.445 85.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2382",
    d: "M722.145,2733.6l-12.549,3-22.306,33.582,66.658-21.159,5.57-5.779-17.311-3.076Z",
    transform: "translate(-687.29 -2733.6)",
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    transform: "translate(23.445 92.537)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "path2414",
    x1: 54.916,
    y2: 30.013,
    fill: "none",
    stroke: "#dfd9dc",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.926,
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigamiCrane);
export default __webpack_public_path__ + "static/media/origami-crane.14b94f6ed5523c7fe9077cf00577804d.svg";
export { ForwardRef as ReactComponent };